<template>
  <div>
    <content-header title="Store" :sub-title="subTitle" class="mb-0 mt--10"/>
    <el-row class="mt-20" :gutter="20" v-if="isLoaded">
      <el-col
        class="mt-15"
        :span="24"
        :lg="6"
        :md="6"
        :xs="24"
        v-for="item in registration.saleableItems"
        :key="item._id"
      >
        <el-card class="item-card" shadow="hover">
          <el-carousel v-if="item.images && item.images.length > 0" trigger="click" height="180px">
            <el-carousel-item v-for="img in item.images" :key="img.uid">
              <img :src="img.url" alt style="object-fit: contain; width: 100%; height: 100%" />
            </el-carousel-item>
          </el-carousel>
          <el-avatar
            v-else
            class="d-flex flex-center fs-25 product-avatar"
            shape="square"
            icon="el-icon-picture"
            :size="150"
            style="object-fit: contain; width: 100%; height: 180px"
          ></el-avatar>
          <div class="mt-10">
            {{item.name}} - ${{ item.price | parsePrice }}
            <span v-if="item.required" class="c-red">*</span>
          </div>
          <div class="mt-05 font-light description fs-08">{{ item.description }}</div>
          <div class="mt-10 font-light description fs-08 c-warning " >
            {{ getLimitPertransactionNotes(item) }}
          </div>
          <div class="mt-05 font-light description fs-08 c-warning ">
            {{ getLimitNotes(item) }}
          </div>
          <div class="card-inputs">
            <el-row :gutter="20" align="end" class="mt-10">
              <el-col :span="12" :offset="0">
                <el-input-number
                  placeholder="Qty"
                  size="small"
                  :min="getMin(item)"
                  :max="getMax(item)"
                  controls-position="right"
                  v-model="item.qty"
                />
              </el-col>
              <el-col :span="12" :offset="0">
                <el-select
                  size="small"
                  v-if="item.requiresSize"
                  class
                  placeholder="Select size"
                  v-model="item.size"
                >
                  <el-option-group
                    v-for="group in getSizeGroups(item)"
                    :key="group.label"
                    :label="group.label"
                  >
                    <el-option
                      v-for="ig in group.options"
                      :key="ig.value"
                      :label="ig.label"
                      :value="ig.value"
                    ></el-option>
                  </el-option-group>
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="mt-20" v-if="isLoaded">
      <el-col :span="24">
        <!--- Desktop Table --->
        <!-- <el-table :data="registration.saleableItems" class="item-table desktop-table">
          <el-table-column label="Product" width="auto">
            <template slot-scope="scope">
              <div class="d-flex align-items-center product-container">
                <div class="flex-0 d-flex align-items-center">
                  <el-avatar class="d-flex flex-center fs-25 product-avatar" shape="square" icon="el-icon-picture" :size="54"></el-avatar>
                </div>
                <div class="product-info flex-1 d-flex flex-column ml-15">
                  <div class="name">{{ scope.row.name }} - ${{ scope.row.price | parsePrice }}<span v-if="scope.row.required" class="c-red">*</span></div>
                  <div class="description">{{ scope.row.description }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="Size" width="150">
            <template slot-scope="scope">
              <el-select v-if="scope.row.requiresSize && nationalId === 7" class="mt-05 w-100" placeholder="Select" v-model="scope.row.size" >
                <el-option-group
                  v-for="group in adultSizes"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
              <el-select v-if="scope.row.requiresSize && nationalId !== 7" class="mt-05 w-100" placeholder="Select" v-model="scope.row.size">
                <el-option-group
                  v-for="group in getSizeGroups(scope.row)"
                  :key="group.label"
                  :label="group.label">
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-option-group>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="date" label="QTY" width="138">
             <template slot-scope="scope">
              <el-input-number :min="0" :max="checkMaxQty(scope.row)" controls-position="right"   v-model="scope.row.qty" />
             </template>
          </el-table-column>
        </el-table> -->

        <!--- Mobile Table --->
        <!-- <el-table :data="registration.saleableItems" class="item-table mobile-table">
          <el-table-column label="Product">
            <template slot-scope="scope">
              <div class="d-flex align-items-center product-container">
                <div class="flex-0 d-flex align-items-center">
                  <el-avatar class="d-flex flex-center fs-25 product-avatar" shape="square" icon="el-icon-picture" :size="54"></el-avatar>
                </div>
                <div class="product-info flex-1 d-flex flex-column ml-15">
                  <div class="name">{{ scope.row.name }}<span v-if="scope.row.required" class="c-red">*</span></div>
                  <div class="name fs-10">${{ scope.row.price | parsePrice }}</div>
                  <div class="description">{{ scope.row.description }}</div>
                </div>
              </div>
              <el-divider class="mt-15"/>
              <div class="d-flex justify-content-end">
                <div v-if="scope.row.requiresSize && nationalId === 7 ">
                  <div class="fs-08">Size:</div>
                  <el-select placeholder="Select" v-model="scope.row.size" style="width: 100px">
                    <el-option-group
                      v-for="group in adultSizes"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div v-if="scope.row.requiresSize && nationalId !== 7">
                  <div class="fs-08">Size:</div>
                  <el-select placeholder="Select" v-model="scope.row.size" style="width: 100px">
                    <el-option-group
                      v-for="group in getSizeGroups(scope.row)"
                      :key="group.label"
                      :label="group.label">
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-option-group>
                  </el-select>
                </div>
                <div class="ml-10">
                  <div class="fs-08">QTY:</div>
                  <el-input-number :min="0" :max="checkMaxQty(scope.row)" controls-position="right" v-model="scope.row.qty" style="width: 90px"/>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table> -->
      </el-col>
      <el-col :span="24">
        <div class="d-flex justify-content-between mx-10">
          <h2>Store Cart Total:</h2>
          <h2>${{cartTotal}}</h2>
        </div>
      </el-col>
    </el-row>
    <el-form ref="form" :model="shipping" v-if="cartQuantity > 0 && this.requireShipping">
      <div>
        <el-divider />
        <h3 class="f-light">Shipping Address</h3>
        <div class="mt--10" v-if="fillingAddress">
          <span type="text" class="text-underline c-highlight fs-09 pointer" @click="fillAddress(fillingAddress)">Fill address with {{ fillingAddress.formatted }}</span>
        </div>
        <el-row :gutter="20">
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Address Line 1</el-input-title>
            <el-form-item prop="address.addressLine1">
              <el-input class="mt-05" v-model="shipping.address.addressLine1" placeholder="Type here..." />
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title>Address Line 2</el-input-title>
            <el-form-item prop="address.addressLine2">
              <el-input class="mt-05" v-model="shipping.address.addressLine2" placeholder="Type here..." />
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>City/Suburb</el-input-title>
            <el-form-item prop="address.suburb">
              <el-input class="mt-05" v-model="shipping.address.suburb" placeholder="Type here..." />
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title :required="nationalId !== 17">State</el-input-title>
            <el-form-item prop="address.state">
              <!-- <el-input class="mt-05" v-model="shipping.address.state" placeholder="Type here..." /> -->
              <el-select v-model="shipping.address.state" placeholder="" filterable class="mt-05 w-100">
                <el-option
                  v-for="{ label, value } in states"
                  :key="value"
                  :label="label"
                  :value="value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Postcode</el-input-title>
            <el-form-item prop="address.postcode">
              <el-input class="mt-05" v-model="shipping.address.postcode" placeholder="Type here..." />
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-10">
            <el-input-title required>Country</el-input-title>
            <el-form-item prop="address.country">
              <el-select v-model="shipping.address.country" placeholder="" filterable class="mt-05 w-100">
                <el-option
                  v-for="{ label, value } in countries"
                  :key="value"
                  :label="label"
                  :value="value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      title="Additional Questions"
      :visible.sync="showAnswerAdditionalQs"
      :before-close="handleClose"
      :append-to-body="true"
      custom-class="additional-qs-dialog"
    >
      <el-col>
        <el-row>
          <additional-questions
            v-for="item in registration.saleableItems"
            :key="item._id"
            :value="item"
          />
        </el-row>
        <el-col></el-col>
        <el-row>
          <el-button class="mt-10" @click="() => showAnswerAdditionalQs = false">Cancel</el-button>
          <el-button class="mt-10" type="primary" @click="submitAdditionalQs">Next</el-button>
        </el-row>
      </el-col>
    </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import {
  allSizes, countries, states, adultSizes
} from '@/utils/constants';
import AdditionalQuestions from '../../../app/components/AdditionalQsAnswerDialog.vue';

export default {
  name: 'Store',
  props: {
    value: Object
  },
  data() {
    return {
      nationalId: +process.env.VUE_APP_NATIONAL_ID,
      isLoaded: false,
      subTitle: 'The entity is offering the following product(s) that can be added to your registration',
      registration: {},
      allSizes,
      countries,
      states,
      shipping: {
        address: {}
      },
      adultSizes,
      nextStep: 4,
      showAnswerAdditionalQs: false,
    };
  },
  components: {
    AdditionalQuestions,
  },
  async mounted() {
    this.isLoaded = false;
    this.registration = this.value;
    this.$emit('update-store', true);

    const sizeGuideListsRes = await this.$http.get('/assemble/api/v1/portal/size-guide-list');
    this.allSizes = this.getFormattedSize(sizeGuideListsRes.data.data);

    _.forEach(this.registration.saleableItems, (i, idx) => {
      if (i.qty === undefined) {
        this.$set(this.registration.saleableItems[idx], 'qty', 0);
      }
    });
    const sIIds = this.registration.saleableItems.map((i) => i.itemId).filter((id) => id !== undefined && id !== null && id !== '');
    if (sIIds.length) {
      const saleableItemsRes = await this.$http.post('/assemble/api/v1/portal/saleable-items/details', { ids: sIIds });
      this.$emit('update-store', false);
      const saleableItems = saleableItemsRes.data.data;
      _.forEach(this.registration.saleableItems, (i, idx) => {
        const item = saleableItems.find((si) => si._id === i.itemId);
        if (!item) return;
        this.$set(this.registration.saleableItems[idx], 'remainingQty', item.remainingQty);
        this.$set(this.registration.saleableItems[idx], 'itemLimit', item.itemLimit);
        this.$set(this.registration.saleableItems[idx], 'hasLimit', item.hasLimit);
        this.$set(this.registration.saleableItems[idx], 'hasTransactionLimit', item.hasTransactionLimit);
        this.$set(this.registration.saleableItems[idx], 'minTransactionLimit', item.minTransactionLimit);
        this.$set(this.registration.saleableItems[idx], 'maxTransactionLimit', item.maxTransactionLimit);
      });
      console.log('this.registration.saleableItems', this.registration.saleableItems);
    }
    this.$emit('update-store', false);
    this.isLoaded = true;
  },
  methods: {
    submitAdditionalQs() {
      this.showAnswerAdditionalQs = false;
      this.processStep(this.nextStep);
    },
    getLimitPertransactionNotes(item) {
      const { maxTransactionLimit, minTransactionLimit, hasTransactionLimit } = item;
      if (!hasTransactionLimit) return '';

      if (maxTransactionLimit && minTransactionLimit) {
        return `Limit ${minTransactionLimit} - ${maxTransactionLimit} per transaction`;
      }
      if (maxTransactionLimit) {
        return `Limit ${maxTransactionLimit} per transaction`;
      }
      if (minTransactionLimit) {
        return `Minimum ${minTransactionLimit} per transaction`;
      }
      return '';
    },
    getLimitNotes(item) {
      const { remainingQty, hasLimit, qty } = item;
      if (!hasLimit) return '';
      if (remainingQty >= 0) {
        const cart = this.$store.getters['cart/directSaleableItems'];
        const cartRegos = this.$store.getters['cart/registrations'];
        console.log('cart', cart);
        const cartItem = cart.find((ci) => ci._id === item.itemId);
        const cartRegoHasMatchingItem = cartRegos.filter((cr) => cr.saleableItems.find((si) => si.itemId === item.itemId));
        let totalQty = 0;
        totalQty = cartRegoHasMatchingItem.reduce((total, cr) => {
          const si = cr.saleableItems.find((s) => s.itemId === item.itemId);
          return total + si.qty;
        }, 0);
        if (cartItem) {
          totalQty += cartItem.qty;
        }

        const available = remainingQty - (qty || 0) - totalQty;
        return available > 0 ? `${available} pieces available` : 'Out Of Stock';
      }

      return '';
    },
    getMin(item) {
      const { minTransactionLimit, hasTransactionLimit } = item;
      if (minTransactionLimit && hasTransactionLimit) {
        return minTransactionLimit === 1 ? 0 : minTransactionLimit;
      }
      return 0;
    },
    getMax(item) {
      const {
        maxTransactionLimit, remainingQty, hasTransactionLimit, hasLimit
      } = item;
      let actualRemainingQty = remainingQty;
      const cart = this.$store.getters['cart/directSaleableItems'];
      const cartRegos = this.$store.getters['cart/registrations'];
      const cartRegoHasMatchingItem = cartRegos.filter((cr) => cr.saleableItems.find((si) => si.itemId === item.itemId));
      const cartItem = cart.find((ci) => ci._id === item.itemId);
      let totalQty = 0;
      totalQty = cartRegoHasMatchingItem.reduce((total, cr) => {
        const si = cr.saleableItems.find((s) => s.itemId === item.itemId);
        return total + si.qty;
      }, 0);

      if (cartItem) {
        totalQty += cartItem.qty;
      }
      actualRemainingQty -= totalQty;
      if (maxTransactionLimit && actualRemainingQty && hasTransactionLimit && hasLimit) {
        return Math.min(maxTransactionLimit, actualRemainingQty);
      } if (maxTransactionLimit && hasTransactionLimit) {
        return maxTransactionLimit;
      } if (actualRemainingQty >= 0 && hasLimit) {
        console.log('here');
        return actualRemainingQty;
      }

      return 999;
    },
    getFormattedSize(allSizesDefault) {
      const formatted = allSizesDefault.map((type) => {
        const options = type.options.map((op) => op.options);
        _.assign(type, { options: _.flattenDeep(options) });
        return type;
      });
      return formatted;
    },
    getSizeGroups(row) {
      return row.sizeList ? row.sizeList : this.allSizes;
    },
    updateStep(step) {
      if (step === -1) return this.$emit('update-step', this.registration, step);
      this.nextStep = step;
      let hasAdditionalQs = false;
      this.saleableItemsWithAdditionalQs = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const item of this.registration.saleableItems) {
        if (item.qty > 0 && _.get(item, 'additionalQs', []).length > 0) {
          hasAdditionalQs = true;
        }
      }
      console.log({
        hasAdditionalQs
      });
      console.log({
        saleableItemsWithAdditionalQs: this.saleableItemsWithAdditionalQs
      });
      if (hasAdditionalQs) {
        this.showAnswerAdditionalQs = true;
        // this.processStep(step);
        // eslint-disable-next-line no-useless-return, consistent-return
        return;
      }
      console.log('Emitting registration data:', this.registration);
      return this.processStep(step);

      // Validate requires size
      // eslint-disable-next-line no-unreachable
      let isValid = true;
      const hasInvalid = [];
      _.forEach(this.registration.saleableItems, (i) => {
        if (i.required && (!i.qty || i.qty <= 0)) {
          isValid = false;
          this.$message.error(`${i.name} is required`);
          hasInvalid.push(false);
          return false;
        }

        if (i.requiresSize && i.qty > 0 && !i.size) {
          isValid = false;
          this.$message.error(`Size is required for ${i.name}`);
          hasInvalid.push(false);
          return false;
        }
        return true;
      });
      // get cart items from store
      // eslint-disable-next-line no-unreachable
      const cartItemsFromStore = this.$store.getters['cart/directSaleableItems'];
      // check if item already in cart
      const foundExceed = this.registration.saleableItems.find((item) => {
        const found = cartItemsFromStore.find((itemFromStore) => itemFromStore._id === item.itemId);
        if (found) {
          if (found.qty + item.qty > found.remainingQty || found.qty + item.qty > found.maxTransactionLimit) {
            return true;
          }
        }
        return false;
      });
      // eslint-disable-next-line no-unreachable
      if (foundExceed) {
        this.$notify({
          title: 'Error',
          message: `${foundExceed.name} exceeds limit, There already ${foundExceed.qty} in cart, you can only add ${foundExceed.remainingQty - foundExceed.qty} more`,
          type: 'error',
        });
        return false;
      }
      if (this.cartQuantity > 0 && this.requireShipping) {
        if (this.$refs.form) {
          this.$refs.form.validate((valid) => {
            if (valid) isValid = true;
            else isValid = false;
          });
        }
      }
      // eslint-disable-next-line no-unreachable
      this.$set(this.registration, 'shipping', this.shipping);

      if (isValid) return this.$emit('update-step', this.registration, step);
      return false;
    },
    processStep(step) {
      // Validate requires size
      let isValid = true;
      const hasInvalid = [];
      _.forEach(this.registration.saleableItems, (i) => {
        if (i.required && (!i.qty || i.qty <= 0)) {
          isValid = false;
          this.$message.error(`${i.name} is required`);
          hasInvalid.push(false);
          return false;
        }

        if (i.requiresSize && i.qty > 0 && !i.size) {
          isValid = false;
          this.$message.error(`Size is required for ${i.name}`);
          hasInvalid.push(false);
          return false;
        }
        return true;
      });
      // get cart items from store
      const cartItemsFromStore = this.$store.getters['cart/directSaleableItems'];
      // check if item already in cart
      const foundExceed = this.registration.saleableItems.find((item) => {
        const found = cartItemsFromStore.find((itemFromStore) => itemFromStore._id === item.itemId);
        if (found) {
          if (found.qty + item.qty > found.remainingQty || found.qty + item.qty > found.maxTransactionLimit) {
            return true;
          }
        }
        return false;
      });
      if (foundExceed) {
        this.$notify({
          title: 'Error',
          message: `${foundExceed.name} exceeds limit, There already ${foundExceed.qty} in cart, you can only add ${foundExceed.remainingQty - foundExceed.qty} more`,
          type: 'error',
        });
        return false;
      }
      if (this.cartQuantity > 0 && this.requireShipping) {
        if (this.$refs.form) {
          this.$refs.form.validate((valid) => {
            if (valid) isValid = true;
            else isValid = false;
          });
        } else {
          console.warn('Form not loaded yet in SaleableItems');
          isValid = false;
        }
      }
      this.$set(this.registration, 'shipping', this.shipping);
      if (isValid && !hasInvalid.length) {
        console.log('Emitting registration data:', this.registration);
        return this.$emit('update-step', this.registration, step);
      }
      return false;
    },
    checkMaxQty(rego) {
      if (rego.multiplePurchaseEnable || rego.multiplePurchaseEnable === undefined) {
        return Infinity;
      }
      return 1;
    },
    fillAddress(address) {
      this.shipping.address = {
        formatted: address.formatted,
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        suburb: address.suburb,
        state: address.state,
        postcode: address.postcode,
        country: address.country,
      };
    },
    searchCountry(query, cb) {
      if (query && query !== '') {
        setTimeout(() => {
          cb(this.countries.filter((item) => item.label.toLowerCase()
            .indexOf(query.toLowerCase()) > -1));
        }, 200);
      } else {
        cb([]);
      }
    },
    handleClose() {
    // Remove any backdrop filters
      document.body.style.backdropFilter = 'none';
      document.body.style.webkitBackdropFilter = 'none';

      this.showAnswerAdditionalQs = false;
      this.isAdditionalQsValid = false;
    },

    showDialog() {
    // Ensure clean state when opening dialog
      document.body.style.backdropFilter = 'none';
      document.body.style.webkitBackdropFilter = 'none';
      this.showAnswerAdditionalQs = true;
    }
  },
  computed: {
    cartTotal() {
      let total = 0;
      _.forEach(this.registration.saleableItems, (i) => {
        total += i.qty * i.price;
      });
      return (total / 100).toFixed(2);
    },
    fillingAddress() {
      const rego = this.value;
      return _.get(rego, 'profile.address.formatted', false) ? rego.profile.address : false;
    },
    cartQuantity() {
      return this.registration.saleableItems && this.registration.saleableItems ? this.registration.saleableItems.reduce((total, item) => total + item.qty, 0) : 0;
    },
    requireShipping() {
      return this.registration && this.registration.saleableItems ? this.registration.saleableItems.some((item) => item.qty > 0 && item.requireShipping) : false;
    },
  },
  filters: {
    parsePrice(val) {
      return (val / 100).toFixed(2);
    }
  }
};
</script>

<style scoped lang="scss">
.item-card {
  border-radius: 8px;
  border-width: 0;
  background-color: rgba(#f7f8fa, .9);
}

.el-input-number {
    width: 100%;
  }
::v-deep .item-table {
  border: 1px solid rgba(45, 58, 69, 0.1);

  &.mobile-table {
    display: none;
  }

  @media only screen and (max-width: $sm) {
    &.mobile-table { display: block !important; }
    &.desktop-table { display: none !important; }
  }

  th {
    background: #F6F8FA !important;
    padding-left: 1em;
    padding-right: 1em;
  }

  td {
    background-color: white !important;
    padding: 2em 1em;
  }
}

.product-container {
  .product-avatar {
    background: white !important;
    border: 1px solid rgba(45, 58, 69, 0.2);
    border-radius: 0;
    color: rgba(45, 58, 69, 0.2);
  }

  .product-info {
    .name {
      color: #2D3A45;
      font-size: 1.2em;
    }

    .description {
      font-family: $fontLight;
    }
  }
}
.additional-qs-dialog {
  // Remove any backdrop filter
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;

  .el-dialog {
    margin-top: 8vh !important;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);

    // Ensure dialog is above other content
    z-index: 3000 !important;
  }

  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #EBEEF5;
  }

  .el-dialog__body {
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px;
    background: white;
  }

  .el-dialog__footer {
    border-top: 1px solid #EBEEF5;
    padding: 20px;
  }
}

// Override global dialog styles
.v-modal {
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}

// Remove padding adjustment when dialog opens
body.el-popup-parent--hidden {
  padding-right: 0 !important;
  overflow: hidden;
}

// Ensure proper stacking
.el-dialog__wrapper {
  z-index: 2999 !important;
}
</style>
